(function () {
  const LOG_PREFIX = '[recharge-prefill]';
  const WIDGET_SELECTORS = [
    '#recharge-storefront-bundling-widget',
    '#recharge-bundles',
    '.recharge-bundles-widget',
    '.rb-app',
  ];
  const PRODUCT_ITEM_SELECTOR = '.recharge-bundle-product-item';
  const ADD_LABELS = ['añadir', 'add'];
  const MAX_ATTEMPTS = 60;
  const RETRY_DELAY_MS = 500;
  const INCREMENT_CLICK_DELAY_MS = 200;
  // Cambiar a true para reactivar logs de depuración en consola
  const DEBUG = false;

  let applied = false;
  let running = false;
  let attemptCount = 0;
  let mutationObserver = null;

  function log() {
    if (!DEBUG) return;
    const args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  function warn() {
    if (!DEBUG) return;
    const args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.warn.apply(console, args);
  }

  function stopObserver(reason) {
    if (!mutationObserver) return;
    mutationObserver.disconnect();
    mutationObserver = null;
    log('MutationObserver desconectado' + (reason ? ' (' + reason + ')' : ''));
  }

  function parseContentsParam() {
    const raw = new URLSearchParams(window.location.search).get('contents');
    log('URL contents param:', raw || '(vacío)');

    if (!raw) return [];

    const items = raw.split(',').reduce(function (acc, entry) {
      const parts = entry.trim().split(':').filter(Boolean);
      if (parts.length < 2) {
        warn('Entrada contents ignorada (formato inválido):', entry);
        return acc;
      }

      let productId;
      let variantId;
      let quantity;

      if (parts.length >= 3) {
        productId = parts[0];
        variantId = parts[1];
        quantity = parseInt(parts[2], 10);
      } else {
        variantId = parts[0];
        quantity = parseInt(parts[1], 10);
      }

      if (!variantId || Number.isNaN(quantity) || quantity < 1) {
        warn('Entrada contents ignorada (ids/cantidad inválidos):', entry);
        return acc;
      }

      acc.push({ productId: productId, variantId: variantId, quantity: quantity });
      return acc;
    }, []);

    log('Items parseados:', items);
    return items;
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function findWidgetRoot() {
    for (let i = 0; i < WIDGET_SELECTORS.length; i++) {
      const selector = WIDGET_SELECTORS[i];
      const el = document.querySelector(selector);
      if (el) return { el: el, selector: selector };
    }
    return null;
  }

  function countProductTargets(root) {
    if (!root) return 0;
    return root.querySelectorAll(
      PRODUCT_ITEM_SELECTOR + ', [data-recharge-variant-id], .rb-item'
    ).length;
  }

  function logAvailableProducts(root) {
    const items = root.querySelectorAll(PRODUCT_ITEM_SELECTOR);
    const variantNodes = root.querySelectorAll('[data-recharge-variant-id]');
    const legacyItems = root.querySelectorAll('.rb-item');

    log('Targets en widget:', {
      productItems: items.length,
      variantNodes: variantNodes.length,
      legacyItems: legacyItems.length,
    });

    const sample = variantNodes.length ? variantNodes : items.length ? items : legacyItems;

    sample.forEach(function (el, index) {
      if (index < 5) {
        log('  [' + index + ']', {
          variantId: el.getAttribute('data-recharge-variant-id'),
          productId: el.getAttribute('data-recharge-product-id'),
        });
      }
    });

    if (sample.length > 5) {
      log('  ... y', sample.length - 5, 'más');
    }
  }

  function waitForWidgetReady() {
    return new Promise(function (resolve) {
      let attempts = 0;

      function check() {
        const widget = findWidgetRoot();

        if (widget && countProductTargets(widget.el) > 0) {
          log('Widget listo:', widget.selector, 'con', countProductTargets(widget.el), 'targets');
          resolve(widget);
          return;
        }

        attempts += 1;

        if (attempts >= MAX_ATTEMPTS) {
          warn('Timeout esperando widget/productos (' + MAX_ATTEMPTS + ' intentos)');
          resolve(widget || null);
          return;
        }

        setTimeout(check, RETRY_DELAY_MS);
      }

      check();
    });
  }

  function matchesAddButton(button) {
    if (!button || button.disabled) return false;
    const text = (button.textContent || '').trim().toLowerCase();
    const aria = (button.getAttribute('aria-label') || '').trim().toLowerCase();

    for (let i = 0; i < ADD_LABELS.length; i++) {
      const label = ADD_LABELS[i];
      if (text === label || text.indexOf(label) !== -1 || aria.indexOf(label) !== -1) {
        return true;
      }
    }
    return false;
  }

  function findVariantNode(root, item) {
    if (item.variantId) {
      const byVariant = root.querySelector('[data-recharge-variant-id="' + item.variantId + '"]');
      if (byVariant) return byVariant;
    }

    if (item.productId) {
      const byProduct = root.querySelector('[data-recharge-product-id="' + item.productId + '"]');
      if (byProduct) return byProduct;
    }

    return null;
  }

  function findProductContext(root, item) {
    const variantNode = findVariantNode(root, item);
    if (!variantNode) return null;

    const card =
      variantNode.closest(PRODUCT_ITEM_SELECTOR) ||
      variantNode.closest('.rb-item') ||
      variantNode.closest('[class*="recharge-bundle-product"]') ||
      variantNode;

    return { variantNode: variantNode, card: card };
  }

  function matchesIncrementButton(button) {
    if (!button || button.disabled || matchesAddButton(button)) return false;

    const text = (button.textContent || '').trim().toLowerCase();
    const aria = (button.getAttribute('aria-label') || '').trim().toLowerCase();
    const name = (button.getAttribute('name') || '').trim().toLowerCase();

    return (
      text === '+' ||
      /aumentar|increment|increase|plus|añadir uno|add one/.test(text) ||
      /aumentar|increment|increase|plus|añadir uno|add one/.test(aria) ||
      /aumentar|increment|increase|plus/.test(name)
    );
  }

  function getClickableElements(root) {
    if (!root) return [];

    const seen = new Set();
    const elements = [];

    root.querySelectorAll('button, [role="button"]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      elements.push(el);
    });

    return elements;
  }

  function findButtons(context) {
    const result = { add: null, increment: null, decrement: null };
    const searchRoots = [context.card, context.variantNode];

    for (let r = 0; r < searchRoots.length; r++) {
      const root = searchRoots[r];
      if (!root) continue;

      const clickables = getClickableElements(root);
      for (let i = 0; i < clickables.length; i++) {
        const el = clickables[i];
        if (el.disabled || el.getAttribute('aria-disabled') === 'true') continue;

        if (!result.add && matchesAddButton(el)) {
          result.add = el;
        }

        if (!result.increment && matchesIncrementButton(el)) {
          result.increment = el;
        }

        if (!result.decrement && matchesDecrementButton(el)) {
          result.decrement = el;
        }
      }

      if (result.add && result.increment) break;
    }

    return result;
  }

  function matchesDecrementButton(button) {
    if (!button || button.disabled || matchesAddButton(button)) return false;

    const text = (button.textContent || '').trim().toLowerCase();
    const aria = (button.getAttribute('aria-label') || '').trim().toLowerCase();
    const name = (button.getAttribute('name') || '').trim().toLowerCase();

    return (
      text === '-' ||
      text === '−' ||
      /reducir|decrement|decrease|minus|quitar uno|remove one/.test(text) ||
      /reducir|decrement|decrease|minus|quitar uno|remove one/.test(aria) ||
      /reducir|decrement|decrease|minus/.test(name)
    );
  }

  function refreshProductContext(root, item) {
    return findProductContext(root, item);
  }

  function findQuantityInput(context) {
    const card = context.card;
    if (!card) return null;

    return (
      card.querySelector('[role="spinbutton"]') ||
      card.querySelector('input[type="number"]') ||
      card.querySelector('.rb-qty-wrapper input, .rb-input')
    );
  }

  function getCurrentQuantity(context) {
    const card = context.card;
    if (!card) return 0;

    const input = findQuantityInput(context);
    if (input) {
      const raw = input.value || input.getAttribute('value') || input.textContent;
      const val = parseInt(String(raw).trim(), 10);
      if (!Number.isNaN(val) && val >= 0) return val;
    }

    const qtyLabel = card.querySelector('[aria-label*="Cantidad"]');
    if (qtyLabel) {
      const match = (qtyLabel.getAttribute('aria-label') || '').match(/(\d+)/);
      if (match) return parseInt(match[1], 10);
    }

    return 0;
  }

  async function waitForQuantityControls(root, item, timeoutMs) {
    const deadline = Date.now() + (timeoutMs || 5000);

    while (Date.now() < deadline) {
      const context = refreshProductContext(root, item);
      if (!context) break;

      const buttons = findButtons(context);

      if (buttons.increment) {
        return { context: context, buttons: buttons };
      }

      await sleep(150);
    }

    const context = refreshProductContext(root, item);
    return {
      context: context,
      buttons: context ? findButtons(context) : { add: null, increment: null },
    };
  }

  function getBundleSelectedCount(root) {
    if (!root) return null;

    const text = root.textContent || '';
    const match = text.match(/(\d+)\s+productos?\s+seleccionados?/i);
    if (!match) return null;

    return parseInt(match[1], 10);
  }

  async function incrementToQuantity(root, item, targetQty) {
    let context = refreshProductContext(root, item);
    if (!context) return 0;

    let currentQty = getCurrentQuantity(context);
    let needed = targetQty - currentQty;

    if (needed <= 0) return currentQty;

    for (let i = 0; i < needed; i++) {
      context = refreshProductContext(root, item);
      if (!context) break;

      const buttons = findButtons(context);
      if (!buttons.increment) {
        warn('No se encontró botón Aumentar en intento', i + 1, 'de', needed);
        break;
      }

      const bundleBefore = getBundleSelectedCount(root);
      log('Click en botón Aumentar (' + (i + 1) + '/' + needed + ')', bundleBefore !== null ? '(bundle: ' + bundleBefore + ')' : '');

      buttons.increment.click();
      await sleep(INCREMENT_CLICK_DELAY_MS);

      currentQty = getCurrentQuantity(refreshProductContext(root, item) || context);
    }

    return currentQty;
  }

  async function addProductQuantity(root, item) {
    log('Añadiendo cantidad:', item.quantity, 'para variant', item.variantId);

    const context = findProductContext(root, item);
    if (!context) {
      warn('Producto NO encontrado:', item);
      return false;
    }

    let currentQty = getCurrentQuantity(context);
    log('Cantidad actual en tarjeta:', currentQty);

    if (currentQty >= item.quantity) {
      log('Producto ya tiene cantidad suficiente, omitiendo');
      return true;
    }

    const buttons = findButtons(context);

    if (buttons.add && currentQty === 0) {
      log('Click en botón Añadir');
      buttons.add.click();
      const controls = await waitForQuantityControls(root, item, 5000);
      if (controls.context) {
        currentQty = getCurrentQuantity(controls.context);
      }
      log('Cantidad tras Añadir:', currentQty, controls.buttons.increment ? '(Aumentar encontrado)' : '(Aumentar NO encontrado)');
    }

    if (currentQty < item.quantity) {
      currentQty = await incrementToQuantity(root, item, item.quantity);
    }

    const bundleCount = getBundleSelectedCount(root);
    log('Resultado final — tarjeta:', currentQty, '| bundle:', bundleCount, '| objetivo:', item.quantity);

    if (currentQty < item.quantity) {
      warn('No se alcanzó la cantidad objetivo en tarjeta');
      return false;
    }

    if (bundleCount !== null && bundleCount < item.quantity) {
      warn('Tarjeta OK pero contador del bundle desincronizado:', bundleCount, 'vs', item.quantity);
      return false;
    }

    return true;
  }

  async function applyPrefill(source) {
    if (applied) {
      return;
    }

    if (running) {
      log('Prefill en curso, ignorando intento desde:', source);
      return;
    }

    const items = parseContentsParam();
    if (!items.length) {
      return;
    }

    running = true;
    stopObserver('inicio prefill');
    attemptCount += 1;

    log('--- Intento de prefill #' + attemptCount + ' (origen:', source + ') ---');

    try {
      const widget = await waitForWidgetReady();
      if (!widget || applied) return;

      const root = widget.el;
      log('Usando contenedor:', widget.selector);

      if (countProductTargets(root) === 0) {
        warn('Widget encontrado pero sin productos renderizados');
        return;
      }

      logAvailableProducts(root);

      let addedCount = 0;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        log('Procesando item', i + 1 + '/' + items.length + ':', item);

        const ok = await addProductQuantity(root, item);
        if (ok) addedCount += 1;

        await sleep(200);
      }

      if (addedCount > 0) {
        applied = true;
        log('Prefill completado. Productos añadidos:', addedCount + '/' + items.length);
      } else {
        warn('Prefill falló: ningún producto se pudo añadir');
      }
    } finally {
      running = false;
    }
  }

  log('Script cargado. URL:', window.location.href);

  document.addEventListener('bundling-widget:ready', function () {
    log('Evento bundling-widget:ready recibido');
    applyPrefill('bundling-widget:ready');
  });

  let observerScheduled = false;

  mutationObserver = new MutationObserver(function () {
    if (applied || running || observerScheduled) return;

    const widget = findWidgetRoot();
    if (!widget || countProductTargets(widget.el) === 0) return;

    observerScheduled = true;
    requestAnimationFrame(function () {
      observerScheduled = false;
      applyPrefill('MutationObserver');
    });
  });

  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(function () {
    stopObserver('45s timeout');
    if (!applied) {
      warn('Prefill no aplicado tras 45s');
    }
  }, 45000);
})();
